import gql from 'graphql-tag'

export const ReportBillingIssue = gql`
  mutation ReportBillingIssue($orderId: String!, $message: String!) {
    reportBillingIssue(orderId: $orderId, message: $message)
  }
`
